module.exports = __webpack_public_path__ + "static/img/flock-logo.aff297d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/flock-logo.png
// module id = MeeK
// module chunks = 1